<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'addRegister',
    components: {
      baseEdit,
    },
  };
</script>
